/* bb cart compact: one-line guarantee + gift card line-item wording (2026-09-26) */
(function () {
  var SHORT = '90-day money-back guarantee';
  function setText(el, txt) {
    var svg = el.querySelector('svg');
    if (el.textContent.trim() === txt) return;
    el.textContent = txt;
    if (svg) el.prepend(svg);
  }
  function fix() {
    document.querySelectorAll('#rebuy-cart .bb-guarantee-line span').forEach(function (s) { if (s.textContent !== SHORT) s.textContent = SHORT; });
    document.querySelectorAll('#rebuy-cart .bb-giftitem').forEach(function (g) {
      var sp = g.querySelector('.bb-giftitem__card span'); if (sp && sp.textContent !== 'Gift card') sp.textContent = 'Gift card';
      var ok = g.querySelector('.bb-giftitem__ok'); if (ok) setText(ok, 'Your order earned this');
      var note = g.querySelector('.bb-giftitem__note'); if (note && note.textContent !== 'Emailed to you after checkout') note.textContent = 'Emailed to you after checkout';
    });
  }
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  fix();
})();
